/* eslint-disable */
import type { firebase } from '../../firebase/firestore';

export interface ISupplierCalendar {
  /**
   * Number of allowed bookings per user
   */
  bookingLimitPerUser?: number;
  /**
   * Buffer after booked time slot. Follows ISO 8601 duration format.
   */
  bufferAfter?: string;
  /**
   * Buffer before booked time slot. Follows ISO 8601 duration format.
   */
  bufferBefore?: string;
  /**
   * Calendar Color
   */
  color?: string;
  /**
   * Number of allowed bookings at one time slot
   */
  concurrencyLimit?: number;
  createdAt: firebase.firestore.Timestamp;
  deletedAt?: firebase.firestore.Timestamp;
  /**
   * Calendar Description
   */
  description?: string;
  /**
   * Duration of time slot. Follows ISO 8601 duration format.
   */
  duration: string;
  /**
   * Calendar Emoji
   */
  emoji?: string;
  endsAt?: firebase.firestore.Timestamp;
  /**
   * Mobiscroll Connect calendar id. Set when type is external.
   */
  externalCalendarId?: string;
  externalCalendarProvider?: ISupplierCalendarEventProvider;
  syncStatus?: ISupplierCalendarSyncStatus;
  /**
   * Increments at which to generate time slots. E.g. '15m' for 15 minutes. Follows ISO 8601 duration format.
   */
  frequencyIncrements?: string;
  /**
   * Calendar UUID
   */
  id: string;
  /**
   * When the calendar last finished syncing with a provider successfully.
   */
  lastSyncedAt?: firebase.firestore.Timestamp;
  /**
   * Location
   */
  location?: string;
  manualApprovalRequired: boolean;
  /**
   * Maximum time of booking in advance. Follows ISO 8601 duration format.
   */
  maxAdvance?: string;
  /**
   * Minimum time of booking in advance. Follows ISO 8601 duration format.
   */
  minAdvance?: string;
  /**
   * Calendar questions
   */
  questions?: ISupplierCalendarQuestion[];
  /**
   * Reminder sent before time slot. Follows ISO 8601 duration format.
   */
  eventReminderOffset?: string;
  startsAt?: firebase.firestore.Timestamp;
  /**
   * Calendar Title
   */
  title: string;
  type: ISupplierCalendarType;
  updatedAt?: firebase.firestore.Timestamp;
}
export interface ISupplierCalendarQuestion {
  createdAt: firebase.firestore.Timestamp;
  deletedAt?: firebase.firestore.Timestamp;
  /**
   * Question UUID
   */
  id: string;
  required: boolean;
  options?: {
    [k: string]: any;
  };
  /**
   * Question text
   */
  text: string;
  /**
   * Question type
   */
  type: 'text' | 'select' | 'checkbox' | 'radio' | 'date' | 'number';
  updatedAt?: firebase.firestore.Timestamp;
}

/**
 * External calendar provider. Set when type is external.
 */
export enum ISupplierCalendarEventProvider {
  Google = 'google',
  Microsoft = 'microsoft',
  Apple = 'apple',
  CalDAV = 'caldav',
}
/**
 * Provider calendar sync lifecycle (e.g. Mobiscroll import, Google push).
 */
export enum ISupplierCalendarSyncStatus {
  Syncing = 'syncing',
  Connected = 'connected',
  Disconnecting = 'disconnecting',
}
/**
 * Supplier Calendar Type
 */
export enum ISupplierCalendarType {
  Showround = 'showround',
  Custom = 'custom',
  Meeting = 'meeting',
  OpenDay = 'openDay',
  External = 'external',
}
